import React from "react";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./authContext";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import AddApplicationPage from "./pages/AddApplication";
import SkillsProgress from "./pages/SkillsProgress";
import "./App.css";

// Navbar Component with active link highlighting
const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/home" className="navbar-logo">
          InternSight
        </Link>
        <ul className="navbar-menu">
          <li className="navbar-item">
            <Link 
              to="/home" 
              className={`navbar-link ${location.pathname === '/home' ? 'active' : ''}`}
            >
              Home
            </Link>
          </li>

          {!user ? (
            <>
              <li className="navbar-item">
                <Link 
                  to="/login" 
                  className={`navbar-link ${location.pathname === '/login' ? 'active' : ''}`}
                >
                  Login
                </Link>
              </li>
              <li className="navbar-item">
                <Link 
                  to="/register" 
                  className={`navbar-link ${location.pathname === '/register' ? 'active' : ''}`}
                >
                  Register
                </Link>
              </li>
            </>
          ) : (
            <>
              <li className="navbar-item">
                <Link 
                  to="/profile" 
                  className={`navbar-link ${location.pathname === '/profile' ? 'active' : ''}`}
                >
                  Profile
                </Link>
              </li>
              <li className="navbar-item">
                <Link 
                  to="/addApplication" 
                  className={`navbar-link ${location.pathname === '/addApplication' ? 'active' : ''}`}
                >
                  Add Application
                </Link>
              </li>
              <li className="navbar-item">
                <Link 
                  to="/skillsProgress" 
                  className={`navbar-link ${location.pathname === '/skillsProgress' ? 'active' : ''}`}
                >
                  Skills Progress
                </Link>
              </li>
              <li className="navbar-item">
                <button onClick={logout} className="navbar-button">
                  Logout
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

// Main App component
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/addApplication" element={<AddApplicationPage />} />
              <Route path="/skillsProgress" element={<SkillsProgress />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;